import { h, Component } from "preact";
import { Link } from "preact-router/match";
import style from "./style";

export default class ArticleItem extends Component {
  render() {
    return (
      <section class={style.acheivements}>
        <div className={style.headingWrapper}>
          <h2 class={style.heading}>{this.props.title}</h2>
          <p class={style.mainDescription}>{this.props.description}</p>
        </div>
        {this.props.children}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./components/articleItem/index.js